// Route /console/session : session live (vidéo + dock outils).
// Auth check + WsProvider + ConfirmProvider + App (layout Session V4).

import { onMount, createSignal, Show } from "solid-js";
import { useNavigate } from "@solidjs/router";
import { App } from "../../operator/app";
import { BugReportWidget } from "../../operator/shared/bug-report-widget";
import { ConfirmProvider } from "../../operator/shared/confirm-dialog";
import { NotifyProvider } from "../../operator/shared/notify";
import { WsProvider } from "../../operator/shared/ws";

import.meta.glob("../../operator/panels/*.tsx", { eager: true });

interface SessionData {
  user: { id: string; email: string; name: string; roles: string[] };
}

export default function ConsoleSessionPage() {
  const navigate = useNavigate();
  const [session, setSession] = createSignal<SessionData | null>(null);
  const [checked, setChecked] = createSignal(false);

  onMount(async () => {
    try {
      const r = await fetch("/api/auth/get-session", { credentials: "include" });
      if (!r.ok) {
        navigate("/login", { replace: true });
        return;
      }
      const data = (await r.json()) as SessionData | null;
      if (!data?.user) {
        navigate("/login", { replace: true });
        return;
      }
      setSession(data);
    } catch (_err) {
      navigate("/login", { replace: true });
    } finally {
      setChecked(true);
    }
  });

  return (
    <Show
      when={checked() && session()}
      fallback={
        <div
          style={{
            display: "flex",
            "align-items": "center",
            "justify-content": "center",
            "min-height": "100vh",
            background: "#0f172a",
            color: "#94a3b8",
            "font-family": "system-ui, sans-serif",
          }}
        >
          Vérification session…
        </div>
      }
    >
      <WsProvider>
        <NotifyProvider>
          <ConfirmProvider>
            <App userEmail={session()!.user.email} userRoles={session()!.user.roles} />
            <BugReportWidget />
          </ConfirmProvider>
        </NotifyProvider>
      </WsProvider>
    </Show>
  );
}
